<template>

    <v-row>
        <v-col md="6">
            <v-card color="light" padding>
                <v-card-title class="headline" v-if="!is_disabled">Add New Account</v-card-title>
                <account-form
                    :submit="onAdd"
                    :is_disabled="is_disabled"
                    :linkAccount="linkAccount"
                    :newAccount="newAccount"
                    :forEdit="forEdit"
                    :emails="[]"
                    :submitText="submitText"
                    ref="newform">
                </account-form>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import AccountForm from './AccountForm'
import { EventBus } from '../../event-bus.js'
import { mapActions } from 'vuex'

export default {
    components: {
        AccountForm
    },
    props: {
        is_disabled: { type: Boolean, default: false },
        newAccount: { type: Boolean, default: false },
        linkAccount: { type: Boolean, default: true },
        forEdit: { type: Boolean, default: true },
        submitText: { type: String, default: "Add" }
    },
    data() {
        return {
            isSubmit: false,
            accountId: 0
        }
    },

    created() {
        // init get users here
        this.$http
            .get('/api/users', {params: { limit: 0 }})
            .then(({ data }) => this.setUserLists(this.parseResponse(data)))
            .catch(err => EventBus.$emit('show-error', 'Failed to fetch users.'));
    },

    methods: {

        ...mapActions('UsersState', ['setUserLists']),

        hasAccId() {
            return this.accountId
        },
        onAdd(data) {
            if (this.is_disabled && this.$refs.newform.isUserAllowed()) {
                let newData = this.$refs.newform.getNewData();
                data.name = newData.name
                data.email = newData.email
                data.roles = newData.roles
                data.password = newData.password
                data.passwordConfirm = newData.passwordConfirm
            }

            if (this.isSubmit) {
                return
            }

            this.isSubmit = true
            this.$http
                .post('/api/accounts', data)
                .then(res => {
                    // show info
                    EventBus.$emit('show-success', 'Successfully saved account.');
                    if (!this.is_disabled) {
                        this.$router.replace({ name: 'account list'});
                    }
                    else {
                        this.accountId = res.data.data.id
                    }

                    this.isSubmit = false
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);

                    if (this.is_disabled && this.$refs.newform.isAllowed()) {
                        // turn off the disabled input
                        this.$refs.newform.checkWork(false)
                    }

                    this.isSubmit = false
                })
        }
    }
}
</script>